import { ElementRef, QueryList, ViewChildren } from '@angular/core';
import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

import { BaseQueovalItem, BreadcrumbModel, BreadDik, ParamApplication, QResult } from '../../models';
import { qDragAndDropCallback } from '../../services';
import { PipeBaseComponent } from '../pipe-base/pipe-base.component';
import { PipeColumn, PipeDisplayMode } from '../models/pipe.model';

import { StagePipeStageCreationComponent } from './stage-creation/stage-creation.component';
import { CursusCreationComponent, CursusDeleteComponent, CursusDuplicateComponent, CursusEditComponent } from './stage-cursus';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { PipeStageVignette, Stage } from '../../models/formation';

@Component({
  selector: 'q-comp-pipe-formation',
  templateUrl: './pipe-formation.component.html',
  styleUrls: ['./pipe-formation.component.css', '../pipe-base/pipe-base.component.css'],
})
export class PipeFormationComponent extends PipeBaseComponent implements OnInit {


  constructor(injector: Injector) {

    super(injector);

    //Route
    this.configParam.routePrefix = 'api/Pipe/Formation/'
    //Filter
    this.configParam.filter.modelGroup = 'STAGE_FILTRE';
    //Column definition
    this.configParam.columnDefinition.codeBo = 'BO_STAGE';
    this.configParam.columnDefinition.codeProperty = 'Etat_PRO';
    this.configParam.columnDefinition.columnFilterGroupe = 'COLPIPESTAGE';
    this.configParam.columnDefinition.tableName = 'TDOProduction';
    this.configParam.columnDefinition.tablePrefix = 'stg';
    this.configParam.columnDefinition.columnOrderBy = 'DatedPRO asc';
    
    // GRID => Nom de la custom grid
    this.configParam.gridModel = !this.indParam.CurrentUrl.GetQueryParam('GRID') ? 'StageModeList' : this.indParam.CurrentUrl.GetQueryParam('GRID');


    //Quick search
    this.configParam
    this.configParam.quickSearch.data = [
      { titre: 'Client', mode: 'CLI', tableName: 'TDOClient', propSearchName: 'RaisoCLI', relationName: 'REL_BO_CENT_BO_CSOC', isBoPere: false, key: 'cli.Ident' },
      { titre: 'Apprenant', mode: 'CNT', tableName: 'TDOPersonne', propSearchName: 'NomfaPER', propDisplayName: 'NomfaPER,Pre01PER', relationName: 'REL_BO_CSOC_BO_CONTACT', isBoPere: false, key: 'cntcli.Ident' },
      { titre: 'Titre ou Numéro du stage', mode: 'TITRENUM', tableName: 'TDOProduction', propSearchName: 'NumstPRO,Info_PRO', relationName: 'REL_BO_CENT_BO_STAGE', isBoPere: false, key: 'stg.ident' },
      { titre: 'Tag', mode: 'TAG', relationName: 'REL_BO_STAGE_BO_TAG', key: 'stg.ident' },
    ]
  }

  @ViewChild('btnFormation') btnTemplate: TemplateRef<any>;
  @ViewChild('cardFormation') cardTemplate: TemplateRef<any>;
  @ViewChild('footerFormation') footerTemplate: TemplateRef<any>;
  @ViewChild('modalFormation') modalTemplate: TemplateRef<any>;

  //@ViewChildren('ScrollViewport') viewPorts: QueryList<CdkVirtualScrollViewport>;
  @ViewChild('modalSettingColumn') modalSettingColumn: ElementRef;

  modalCreationStage: NgbModalRef;

  protected cardClickCallBack(data: qDragAndDropCallback) {
    this.openStage(data.ident, PipeDisplayMode.Pipe);
  }

  protected gridClickCallBack(res: any) {
    this.openStage(res.Value, PipeDisplayMode.Grid);
  }

  public openSettingCol() {

    this.currentColumnModel = new ParamApplication();
    this.selectedColumn = new Array<string>();

    this.http.postHttp<QResult<Array<BaseQueovalItem>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_ALL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<BaseQueovalItem>>) => {
        this.columnList = data.Value;
      });

    this.http.postHttp<QResult<Array<ParamApplication>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_MODEL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<ParamApplication>>) => {
        this.columnModelList = data.Value;
      });
    this.modalService.open(this.modalSettingColumn, { centered: true, size: 'lg', windowClass: 'qmodalover' });
  }

  public openStage(idStage: string, displayMode: PipeDisplayMode) {
    if (this.modalCreationStage) {
      this.modalCreationStage.close();
    }

    this.saveNavigationParam();
    this.breadcrumb.call(new BreadcrumbModel('add', `view/formations/stage-detail/${idStage}`, null, 'Detail stage', true));
  }

  public filterBtnClick(event: any) {
    switch (event.Value) {
      case 'createCursus':
        this.cursusCreation.openModal();
        break;
      case 'editCursus':
        this.cursusEdit.openModal(event.Text);
        break;
      case 'deleteCursus':
        this.cursusDelete.openModal(event.Text);
        break;
      case 'duplicateCursus':
        this.cursusDuplication.openModal(event.Text);
        break;
      default:
        break;
    }
  }

  protected afterGetCardsPipe(columns: Array<PipeColumn> | undefined = undefined) {
    if (!columns) return;
    const columnMap = new Map();
    columns.forEach(column => {
      column.cards.forEach(card => {
        columnMap.set(card.Ident, card);
      });
    });
    this.http.postHttp<QResult<any>>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/InfoStage/GET_CARD_INFO`, Array.from(columnMap).map(([key]) => key)).subscribe(result => {
      result.Value.forEach((cardInfo: PipeStageVignette) => {
        let cardData = columnMap.get(cardInfo.Ident);
        if (cardData) {
          cardData.NbPreinscrit = cardInfo.NbPreinscrit;
          cardData.MontantPictoColor = cardInfo.MontantPictoColor;
          cardData.MontantPictoTitle = cardInfo.MontantPictoTitle;
          cardData.Formateur = cardInfo.Formateur;


          if (cardInfo.Formateur?.length > 0) {
            cardData.FormateurToDisplay = cardInfo.Formateur.slice(0, 5);
            cardData.FormateurPictoHint = cardInfo.Formateur.length - 5 > 0 ? cardInfo.Formateur.length - 5 : 0
            cardData.FormateurPictoTitle = cardInfo.Formateur.map(formateur => `${formateur.Firstname} ${formateur.Lastname}\n`);
          }
          cardData.Client = cardInfo.Client;
          cardData.ClientTitle = cardInfo.ClientTitle;
        }
      });
    });
  }


  protected afterGetCardsGrid(filtredIdent: String[] | undefined = undefined) {
    this.http.postHttp<QResult<any>>(`${this.indParam.AppParams.apiUrl}api/Pipe/Formation/InfoStage/INFO_SUPPLEMENTAIRE_GRID`, filtredIdent).subscribe(result => {
      this.gridUpdateValue = result.Value;
    });
  }

  protected afterBaseInit() {
    //retire l'option client de la quicksearch si l'on est dans le contexte client 
    if (this.treeveiwParam.filter.toLocaleLowerCase().includes('cli.ident')) {
      const splitedFilter = this.treeveiwParam.filter.split(';');
      for (let i = 0; i < splitedFilter.length; i += 2) {
        if (i + 1 == splitedFilter.length) break;
        if (splitedFilter[i].toLocaleLowerCase() == 'cli.ident') {
          this.configParam.quickSearch.data = this.configParam.quickSearch.data.filter(x => x.mode != 'CLI');
          break;
        }
      }
    }  
  }
  //#region Specifique

  //#region Creation Stage
  public colType: string;
  @ViewChild(StagePipeStageCreationComponent) stageCreate: StagePipeStageCreationComponent;

  public openModalCreateStage(event: Event, column: PipeColumn | null) {
    this.colType = column != null ? column.columnSelector[0].PropValue : '';
    this.stageCreate.openModal();
  }
  //#endregion


  //#region Creation cursus
  @ViewChild(CursusCreationComponent) cursusCreation!: CursusCreationComponent;
  @ViewChild(CursusDeleteComponent) cursusDelete!: CursusDeleteComponent;
  @ViewChild(CursusDuplicateComponent) cursusDuplication!: CursusDuplicateComponent;
  @ViewChild(CursusEditComponent) cursusEdit!: CursusEditComponent;

  public closeDeleteCursus(deletionAvailable: boolean) {
    if (!deletionAvailable) return;

    // Rafraichissement de la liste des filtres
    let filtreEnCours = this.filterBadges.filter(filtre => filtre.PropKey != 'cycle.ident');
    let reload = filtreEnCours.length != this.filterBadges.length;
    this.filterBadges = filtreEnCours;
    this.buildFilter();
    if (reload) {
      this.onFilterChange(this.filterBadges);
    }

    // Rechargement en mode Grid
    if (this.configParam.displayMode != PipeDisplayMode.Pipe) {
      this.getCards().pipe(first()).subscribe();
    }
  }

  public closeDuplicateCursus() {
    // Rafraichissement de la liste des filtres
    this.buildFilter();
    this.onFilterChange(this.filterBadges);
  }

  public closeEditCursus() {
    this.buildFilter();
  }
  //#endregion

  //#endregion
}
